export default "__VITE_ASSET__ae875478__"